import { cva } from '@/styled-system/css';

export const checkboxRecipe = cva({
  base: {
    display: 'inline-block',
    width: 'Checkbox.box',
    height: 'Checkbox.box',

    borderWidth: 'thick',
    borderStyle: 'solid',
    borderRadius: 'Checkbox.box',
    backgroundPosition: 'center',
    backgroundSize: '{sizes.icon.sm}',
    backgroundRepeat: 'no-repeat',
    transition: {
      _motionReduce: 'none',
      _motionSafe: 'box-shadow 200ms ease',
    },
  },
  variants: {
    indeterminate: {
      true: {
        backgroundColor: 'bg.action.hero.selected.default',
        borderColor: 'border.action.hero.selected.default',
        backgroundImage: {
          base: `url("data:image/svg+xml;utf8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20aria-hidden%3D%22true%22%20viewBox%3D%220%200%2032%2032%22%3E%3Cpath%20d%3D%22M26%2018H6a2%202%200%200%201%200-4h20a2%202%200%200%201%200%204z%22%20fill%3D%22%23FFF%22%2F%3E%3C%2Fsvg%3E")`,
          _dark: `url("data:image/svg+xml;utf8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20aria-hidden%3D%22true%22%20viewBox%3D%220%200%2032%2032%22%3E%3Cpath%20d%3D%22M26%2018H6a2%202%200%200%201%200-4h20a2%202%200%200%201%200%204z%22%20fill%3D%22%23000%22%2F%3E%3C%2Fsvg%3E")`,
        },
      },
      false: {
        '&:checked': {
          backgroundColor: 'bg.action.hero.selected.default',
          borderColor: 'bg.action.hero.selected.default',
          backgroundImage: {
            base: `url("data:image/svg+xml;utf8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20aria-hidden%3D%22true%22%20viewBox%3D%220%200%2032%2032%22%3E%3Cpath%20d%3D%22M29.41%206.57a2%202%200%200%200-2.83%200L11.36%2021.32l-5.95-5.77a2%202%200%200%200-2.83%200%201.9%201.9%200%200%200%200%202.74L10%2025.43a2%202%200%200%200%202.83%200L29.41%209.31a1.9%201.9%200%200%200%200-2.74z%22%20fill%3D%22%23FFF%22%2F%3E%3C%2Fsvg%3E")`,
            _dark: `url("data:image/svg+xml;utf8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20aria-hidden%3D%22true%22%20viewBox%3D%220%200%2032%2032%22%3E%3Cpath%20d%3D%22M29.41%206.57a2%202%200%200%200-2.83%200L11.36%2021.32l-5.95-5.77a2%202%200%200%200-2.83%200%201.9%201.9%200%200%200%200%202.74L10%2025.43a2%202%200%200%200%202.83%200L29.41%209.31a1.9%201.9%200%200%200%200-2.74z%22%20fill%3D%22%23000%22%2F%3E%3C%2Fsvg%3E")`,
          },
        },
        '&:not(:checked)': {
          backgroundColor: 'bg.neutral',
          borderColor: 'border.action.neutral.default',
        },
      },
    },
    disabled: {
      true: {
        opacity: 'disabled',
      },
      false: {
        'focusOutline': true,
        '_hover': {
          cursor: 'pointer',
        },
        '&:checked': {
          _hover: {
            borderColor: 'bg.action.hero.selected.hover',
            backgroundColor: 'bg.action.hero.selected.hover',
          },
          _active: {
            borderColor: 'bg.action.hero.selected.pressed',
            backgroundColor: 'bg.action.hero.selected.pressed',
          },
        },
        '&:not(:checked)': {
          _hover: {
            backgroundColor: 'bg.neutral',
            borderColor: 'Checkbox.border.hover',
          },
          _active: {
            backgroundColor: 'bg.neutral',
            borderColor: 'Checkbox.border.pressed',
          },
        },
      },
    },
  },
  compoundVariants: [
    {
      disabled: false,
      indeterminate: true,
      css: {
        '&:checked,&:not(:checked)': {
          _hover: {
            backgroundColor: 'bg.action.hero.selected.hover',
            borderColor: 'border.action.hero.selected.hover',
          },
          _active: {
            backgroundColor: 'bg.action.hero.selected.pressed',
            borderColor: 'border.action.hero.selected.pressed',
          },
        },
      },
    },
  ],
});
